<template>
  <Layout>
    <div class="row">
      <div class="col-md-10 mb-4 mx-auto">
        <h3 class="mb-4">{{ $t(title) }}</h3>
        <div class="alert alert-danger" role="alert" v-if="isChecked">
          {{ msgErr }}
        </div>
        <form @submit.prevent="onSubmit">
          <div class="row mt-2">
            <div class="col">
              <label>{{ $t("pages.password.pass") }}</label>
              <input type="password" v-model.trim="old_password" class="form-control" required />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-6">
              <label>{{ $t("pages.password.newPass") }}</label>
              <input type="password" v-model.trim="new_password" @change="validPwd" class="form-control mb-4" required />
            </div>

            <div class="col-md-6">
              <label>{{ $t("pages.password.confirmPass") }} </label>
              <input type="password" v-model.trim="confirm_password" class="form-control mb-4" required />
            </div>
          </div>
          <div class="row">
            <div class="col mt-4">
              <h6>
                
                {{ $t("pages.password.message") }}
              </h6>
              <h6>
                <i class="bx bxs-check-circle text-success"></i>
                {{ $t("pages.password.confirmation") }}
              </h6>
              <h6>
                <i class="bx bxs-check-circle text-success"></i>
                {{ $t("pages.password.number") }}
              </h6>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col text-left mt-2">
              <button v-if="isChecked" type="submit" class="btn btn-primary" disabled>
                {{ $t("pages.password.save") }}
              </button>
              <button v-else-if="this.isLoading === false" type="submit" class="btn btn-primary">
                {{ $t("pages.password.save") }}
              </button>
              <button class="btn btn-primary" type="button" v-else disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ $t("pages.password.saving") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapState } from "vuex";
// import axios from 'axios';
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Mot de Passe",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      title: "pages.password.title",
      items: [
        {
          text: "pages.profile.title",
        },
        {
          text: "pages.password.text",
          active: true,
        },
      ],
      error: {
        wrong: "pages.error.wrong"
      },

      old_password: "",
      new_password: "",
      confirm_password: "",
      isLoading: false,
      msgErr: "",
      isChecked: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
  },
  watch: {
    new_password: function() {
      return this.validPwd();
    }
  },
  methods: {
    ...mapActions(["resetUserPassword", "getUserById"]),
    onSubmit() {
      if (this.new_password === this.confirm_password) {
        this.$toasted.clear();
        this.isLoading = true;
        const data = {
          old_password: this.old_password,
          new_password: this.new_password,
          confirm_password: this.confirm_password
        }
        this.resetUserPassword(data)
          .then(() => {
            this.isLoading = false;
            this.$toasted.success(this.$t("pages.error.success"));
            this.$router.push( { name: 'default'});
          })
          .catch(() => {
            this.isLoading = false;
            this.$toasted.error(this.$t("pages.error.wrong"));
          });
      } else {
        this.$toasted.error(this.$t("pages.error.different"));
      }
    },
    validPwd() {
      if (this.new_password.length < 8) {
        this.msgErr = this.$t("pages.password.warning.min");
        this.isChecked = true;
      } else if (!/[A-Z]/.test(this.new_password)) {
        this.msgErr = this.$t("pages.password.warning.upper");
        this.isChecked = true;
      } else if (!/[a-z]/.test(this.new_password)) {
        this.msgErr = this.$t("pages.password.warning.lower");
        this.isChecked = true;
      } else if (!/[0-9]/.test(this.new_password)) {
        this.msgErr = this.$t("pages.password.warning.number");
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
    },
  },
  created() {
    
  },
};
</script>
